module.exports = __webpack_public_path__ + "static/img/CyberSecurity-Rgh.1b49e98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Sectors/CyberSecurity-Rgh.jpg
// module id = 7wTu
// module chunks = 1